var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import PaginationNavigationButtonPageNumber from "./PaginationNavigationButtonPageNumber";
import PaginationNavigationButtonEllipsis from "./PaginationNavigationButtonEllipsis";
import { classNames } from "../../../Util";
var range = function (from, to) {
    var length = to - from + 1;
    return Array.from({ length: length }, function (_, i) { return i + from; });
};
var paginationRange = function (currentPage, totalPageCount, siblingCount, totalPageNumbers) {
    if (totalPageNumbers >= totalPageCount) {
        return range(1, totalPageCount);
    }
    var leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    var rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
    var shouldShowLeftDots = leftSiblingIndex > 2;
    var shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
    var firstPageIndex = 1;
    var lastPageIndex = totalPageCount;
    if (!shouldShowLeftDots && shouldShowRightDots) {
        var leftItemCount = 3 + 2 * siblingCount;
        var leftRange = range(1, leftItemCount);
        return __spreadArray(__spreadArray([], leftRange, true), [undefined, totalPageCount], false);
    }
    if (shouldShowLeftDots && !shouldShowRightDots) {
        var rightItemCount = 3 + 2 * siblingCount;
        var rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
        return __spreadArray([firstPageIndex, undefined], rightRange, true);
    }
    if (shouldShowLeftDots && shouldShowRightDots) {
        var middleRange = range(leftSiblingIndex, rightSiblingIndex);
        return __spreadArray(__spreadArray([firstPageIndex, undefined], middleRange, true), [undefined, lastPageIndex], false);
    }
    return [];
};
var PaginationNavigation = function (_a) {
    var page = _a.page, pageRequest = _a.pageRequest, setPageRequest = _a.setPageRequest, _b = _a.compactPagination, compactPagination = _b === void 0 ? false : _b;
    var _c = useState(), renderedButtons = _c[0], setRenderedButtons = _c[1];
    useEffect(function () {
        if (compactPagination) {
            return;
        }
        var currentPage = pageRequest.pageNumber;
        var totalPageCount = page.totalPages;
        var siblingCount = 1;
        var totalPageNumbers = siblingCount + 5;
        var newRender = paginationRange(currentPage, totalPageCount, siblingCount, totalPageNumbers).map(function (pageNumber, i) {
            return (pageNumber === undefined
                ? _jsx(PaginationNavigationButtonEllipsis, {}, i)
                : _jsx(PaginationNavigationButtonPageNumber, { pageNumber: pageNumber, active: pageNumber === (currentPage + 1), onClick: function () { return setPageRequest(__assign(__assign({}, pageRequest), { pageNumber: pageNumber - 1 })); } }, i));
        });
        setRenderedButtons(newRender);
    }, [pageRequest]);
    return (_jsx("div", __assign({ className: "ml-4" }, { children: _jsxs("nav", __assign({ className: "isolate inline-flex -space-x-px rounded-md shadow-sm" }, { children: [_jsx("button", __assign({ disabled: page.first, onClick: function (e) {
                        e.preventDefault();
                        setPageRequest(__assign(__assign({}, pageRequest), { pageNumber: pageRequest.pageNumber - 1 }));
                    }, className: classNames("relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20", page.first ? "opacity-40" : "") }, { children: _jsx(ChevronLeftIcon, { className: "h-5 w-5", "aria-hidden": "true" }) })), renderedButtons && renderedButtons, _jsx("button", __assign({ disabled: page.last, onClick: function (e) {
                        e.preventDefault();
                        setPageRequest(__assign(__assign({}, pageRequest), { pageNumber: pageRequest.pageNumber + 1 }));
                    }, className: classNames("relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20", page.last ? "opacity-40" : "") }, { children: _jsx(ChevronRightIcon, { className: "h-5 w-5", "aria-hidden": "true" }) }))] })) })));
};
export default PaginationNavigation;
